export default "__VITE_ASSET__813020e7__"